export default __webpack_public_path__ + "static/logo_ams-a0576ef607f5a82554d14a679afdebd3.png";